
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Component displays call  pause svg icon 
 * @param props -SvgIconProps
 * @returns pause svg icon
 * @example - <CcfAudioPauseIcon/>
 */
export function CcfAudioPauseIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="Pause">
        <g id="Group_119238" data-name="Group 119238" transform="translate(3.323 1)">
          <g id="Group_63" data-name="Group 63" transform="translate(0 0)">
            <path id="Path_9" data-name="Path 9" d="M-155.938-141.226a2.477,2.477,0,0,1-2.323-2.323V-156.9a2.477,2.477,0,0,1,2.323-2.323,2.473,2.473,0,0,1,2.323,2.323v13.355A2.473,2.473,0,0,1-155.938-141.226Z" transform="translate(158.26 159.226)"/>
          </g>
          <g id="Group_64" data-name="Group 64" transform="translate(8.71 0)">
            <path id="Path_10" data-name="Path 10" d="M-152.046-141.226a2.475,2.475,0,0,1-2.323-2.323V-156.9a2.475,2.475,0,0,1,2.323-2.323,2.477,2.477,0,0,1,2.323,2.323v13.355A2.476,2.476,0,0,1-152.046-141.226Z" transform="translate(154.368 159.226)"/>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfAudioPauseIcon;